import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CoreService } from '../../services/coreService';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../../language.service';
interface TranslationObject {
  location: string;
  carRequested: string;
  requestedTime: string;
  riyadhPark: string;
  description: string;
  amount: string;
  valetFees: string;
  total: string;
  sar: string;
  carParkedAt: string;
  checkInTime: string;
  keySlotNo: string;
}
declare var toastr: any;

@Component({
    selector: 'app-my-car',
    templateUrl: './my-car.component.html',
    styleUrls: ['./my-car.component.scss'],
    standalone: true,
    imports: []
})

export class MyCarComponent implements OnInit {
  logo = environment.logo_path;
  vehicleDetails :any;
  sub:any;
  selectedLanguage="en";
  currentLanguage: string;
  currentTranslation: TranslationObject;

  constructor(private languageService: LanguageService,public coreService: CoreService,private route: ActivatedRoute) {
      this.sub = this.route.params.subscribe(params => {
      this.getVehicleDetails(params["id"]); 
    });    
   }

   ngOnInit(): void {
    this.updateTranslation();
    this.currentLanguage = this.languageService.getLanguage();
  }

  changeLanguage(): void {
    const newLanguage = this.languageService.getLanguage() === 'eng' ? 'arb' : 'eng';
    this.languageService.setLanguage(newLanguage);
    this.updateTranslation();
  }

  private updateTranslation(): void {
    this.currentTranslation = this.languageService.getCurrentLanguageObject();
    this.currentLanguage = this.languageService.getLanguage();

  }

  getVehicleDetails(id){
    localStorage.setItem("valet-ticket",id); 
    this.coreService.GetVehicleDetailsMyCar(id)
     .toPromise()
     .then((response : any) => {
      this.vehicleDetails=response.data;
      console.log(this.vehicleDetails)
     }) 
  }

  payment(){   
    if(this.vehicleDetails.amount != "0.000"){
    var form={
      "amount": this.vehicleDetails.amount,
      "type": "debit",
      "currency":"SAR",
      "msisdn":this.vehicleDetails.valet_user.mobile_number,
      "valet_ticket_id": localStorage.getItem("valet-ticket"),
      "ticket":localStorage.getItem("valet-ticket"),
    }

   this.coreService.Payment(form)
     .toPromise()
     .then((response : any) => { 
       window.location.replace(response.payment_url);
     })
  } 
  else{
    toastr.error("You are in grace period");
  } 
}
}
